import { inject, Injectable, Signal } from "@angular/core";
import { Article } from "../../models/article.model";
import { ArticleApiService } from "./article-api.service";
import { ArticleState, ArticleStoreService } from "./article-store.service";
import { EntityFacadeService } from "../../../../shared/store/entity-store/entity-facade.service";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { SpecifDuplicatePayload } from "../../models/article-payload-duplicate.model";
import { firstValueFrom } from "rxjs";
import { UpdateStatus } from "../../../../shared/store/utils/store-utils.service";
import { ArticlesInfosFacadeService } from "../article-infos/article-infos-facade.service";
import { StatsArticleDialogComponent } from "../../containers/stats-article-dialog/stats-article-dialog.component";
import { DialogsService } from "../../../../shared/services/dialogs/dialogs.service";

@Injectable({ providedIn: "root" })
export class ArticleFacadeService extends EntityFacadeService<
  Article,
  ArticleApiService,
  ArticleState,
  EntityMetadata,
  ArticleStoreService
> {
  dialogs = inject(DialogsService);
  articleInfosFacade = inject(ArticlesInfosFacadeService);

  constructor() {
    const api = inject(ArticleApiService);
    const store = inject(ArticleStoreService);
    super(api, store);
    store.initStatus(ArticleFacadeService);
  }

  initState() {
    this.store.patchState({
      stats: null,
    });
  }

  @UpdateStatus
  async duplicate(specifPayload: SpecifDuplicatePayload) {
    const res = await firstValueFrom(this.api.duplicate(specifPayload));
    if (res.article.articleInfos) {
      this.articleInfosFacade.store.upsertOne(res.article.articleInfos);
    }
    return res;
  }

  @UpdateStatus
  async upsert(entity: Article): Promise<Signal<Article>> {
    let saved;
    if (entity.id) {
      saved = await this.update(entity);
    } else {
      saved = await this.add(entity);
    }
    if (saved().articleInfos) {
      this.articleInfosFacade.store.upsertOne(saved().articleInfos);
    }
    return saved;
  }

  @UpdateStatus
  async stats(payload: {
    articleId: string;
    dateDebut: Date;
    dateFin: Date;
    search: string;
  }) {
    const stats = await firstValueFrom(this.api.stats(payload));

    this.store.getWritableState().stats.set(stats);
  }

  onStats(articleId: string) {
    this.dialogs.open(StatsArticleDialogComponent, "95dvw", "95dvh", {
      articleId,
    });
  }
}
